
<template>
<section>
  <div class="columns">
    <div class="col">
      <chc-input v-model="data.first_name" :error="errors.first_name" label="First Name" :required="true"></chc-input>
      <chc-input v-model="data.last_name"  :error="errors.last_name" label="Last Name" :required="true"></chc-input>
      <chc-input v-model="data.email" label="Email" :error="errors.email" :required="true"></chc-input>
      <chc-input v-model="data.user_role" label="User Type" format="combo"
                 :error="errors.user_role"
                 :autoCompleteValues="$store.state.constants.users.user_types"
                 :required="true"></chc-input>

      <chc-input v-model="data.mobile" label="Phone"
                 :error="errors.mobile"
                 v-if="data.user_role == 'admin'"></chc-input>

      <chc-input v-model="data.charity_id" label="Charity"
                 :error="errors.charity_id"
                 v-if="data.user_role == 'charity'"
                 :autoCompleteValuesHidden="$store.state.summary.charities"
                 :autoCompleteValues="$store.state.summary.charities_active" format="combo"
                 :required="true"></chc-input>

      <chc-input v-model="data.charity_id" label="Charity"
                 :error="errors.charity_id"
                 v-if="data.user_role == 'charity_prospect'"
                 :autoCompleteValuesHidden="$store.state.summary.charities"
                 :autoCompleteValues="$store.state.summary.charities_prospect" format="combo"
                 :required="true"></chc-input>

      <chc-input v-model="data.call_center_id" label="Call Center"
                 v-if="data.user_role == 'call'"
                 :error="errors.call_center_id"
                 :autoCompleteValues="$store.state.summary.call_centers" format="combo"
                 :required="true"></chc-input>

      <div class="field" v-if="data.active">
        <a @click="resendRegistration" class="registration">Resend Registration Email</a>
        <p class="registration">(Save all changes before resending)</p>
        <p v-if="resendSuccess === true" class="registration success-message">Registration email sent</p>
        <p v-if="resendSuccess === false" class="registration error-message">Unable to resend registration email</p>
      </div>

      <span v-if="hasErrors" class="error-message error-block">
        There were errors processing the form. Please fix the fields above.
      </span>
      <span v-if="!data.active" class="error-message error-block">User is deactivated</span>
      <div class="field submit-section split">
        <input @click="submit" type="submit" class="btn" value="Save Changes" :disabled="showConfirmation || !data.active">
        <div>
          <a v-if="!showConfirmation" @click="showConfirmation=true">{{ confirmationValue }} User</a>
        </div>
      </div>

      <div v-if="showConfirmation" class="field">
        <p>{{ confirmationMessage }}</p>
        <div class="split">
          <input type="submit" v-if="data.active" @click="deactivate" class="btn" :value="confirmationValue">
          <input type="submit" v-if="!data.active" @click="reactivate" class="btn" :value="confirmationValue">
          <div>
            <a @click="showConfirmation=false">Cancel</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'UsersEdit',
  data () {
    return {
      isLoading: false,
      errors: {},
      hasErrors: false,
      showConfirmation: false,
      resendSuccess: null,
    }
  },
  props: ['userId', 'data'],
  methods: {
    submit () {
      store.functions.users.editUser(
        this.userId,
        this.data,
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        })
        .then(() => {
          this.hasErrors = false
          this.$router.push({name: 'UsersSummary'})
          this.$emit('refresh')
          this.$emit('close')
        })
    },
    deactivate () {
      store.functions.users.deactivateUser(
        this.userId,
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        })
        .then(() => {
          this.hasErrors = false
          this.$router.push({name: 'UsersSummary'})
          this.$emit('refresh')
          this.$emit('close')
        })
    },
    reactivate () {
      store.functions.users.reactivateUser(
        this.userId,
        this.data,
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        })
        .then(() => {
          this.hasErrors = false
          this.$router.push({name: 'UsersSummary'})
          this.$emit('refresh')
          this.$emit('close')
        })
    },
    resendRegistration () {
      if (this.isLoading) return
      if (!this.data.active) return
      this.isLoading = true
      store.functions.users.resendRegistration(this.userId,
        (errors) => {
          this.resendSuccess = false
          this.isLoading = false
        }).then(() => {
        this.resendSuccess = true
        this.isLoading = false
      }).catch((error) => {
        console.log(error)
        this.resendSuccess = false
        this.isLoading = false
      })
    },
  },
  computed: {
    confirmationMessage () {
      if (this.data.active) return 'Are you sure you want to deactive this user?'
      else return 'Are you sure you want to reactivate this user?'
    },
    confirmationValue () {
      if (this.data.active) return 'Deactivate'
      else return 'Reactivate'
    }
  }
}
</script>

<style scoped>

.split {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.split input {
    width: 10em;
}

.field .registration {
  width: 100%;
  margin: 0px;
  padding: 0.5rem 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Users/UsersEdit.vue